import { useEffect } from "react";
import posthog from 'posthog-js';
import  supabase  from "../supabaseClient";  // Import your Supabase client
import Navbar from "../components/navbar";
import HomeHero from "../components/hero";
import Destination from "../components/destination";
import Footer from "../components/footer";
import Trip from "../components/trip";
import Homeimg from "../assets/12.webp";

function Home() {
  useEffect(() => {
    // Capture start time for time spent on page
    const startTime = Date.now();

    // Fetch user details from Supabase, including the profile
    const fetchUser = async () => {
      // Get the authenticated user
      const { data: { user }, error: userError } = await supabase.auth.getUser();

      if (userError) {
        console.error("Error fetching user:", userError);
        return;
      }

      console.log("Authenticated user:", user);

      // Fetch user profile (first name, last name, and email) from the profiles table
      const { data: profile, error: profileError } = await supabase
        .from('profiles')
        .select('first_name, last_name, email')
        .eq('user_id', user.id)  // Ensure you're using the correct column for the user ID
        .single();

      if (profileError) {
        console.error("Error fetching user profile:", profileError);
        return;
      }

      console.log("User profile data:", profile);

      // Combine first and last name to form full name
      const userEmail = profile.email || user.email;
      const userFullName = `${profile.first_name || ''} ${profile.last_name || ''}`.trim();

      // Identify the user in PostHog using their email as the distinct ID
      posthog.identify(userEmail, {
        email: userEmail,
        name: userFullName || "Unknown"
      });

      console.log("PostHog distinct ID (email):", userEmail);

      // Track the homepage visit
      posthog.capture('Homepage Visited', {
        distinct_id: userEmail,
        url: window.location.href
      });

      // Capture time spent on page when the user leaves
      return () => {
        const timeSpent = Date.now() - startTime;
        posthog.capture('Homepage Time Spent', {
          distinct_id: userEmail,
          timeSpentInSeconds: Math.round(timeSpent / 1000) // Time in seconds
        });
      };
    };

    fetchUser();
  }, []);

  return (
    <>
      <Navbar />
      <HomeHero
        cName="hero"
        heroImg={Homeimg}
        title="Your Gateway to Discovery"
        text="Choose Your Favourite Destination."
        btnClass="show"
        buttonText="Travel Plan"
        url="/"
      />
      <Destination />
      <Trip />
      <Footer />
    </>
  );
}

export default Home;
